<ng-container >
    <ng-select (change)="sendResponse($event)" class="custom" [items]="items" [bindLabel]="label" [bindValue]="value"
[formControl]="inputFormControl" [ngClass]="{'input-has-error':inputFormControl?.touched && inputFormControl?.errors}" [placeholder]="placeholder">
</ng-select>
<div class="has-error" *ngIf="inputFormControl?.touched  && inputFormControl?.errors?.required">
    {{displayName}} is required.
</div>
</ng-container>
